import { defineStore } from 'pinia';
import { computed, ref } from "vue";
import { useRoute, useRouter } from "vue-router";
import axios from "axios";

export const useBasketStore = defineStore('basket-store',  () => {

  // TODO: use in DocViewerPage too
  const basketId = ref()
  const basketIndex = ref()
  const basketData = ref({})
  const currentDocumentData = ref({})

  const isFirstDoc = computed(() => basketIndex.value === 0 )
  const isLastDoc = computed(() => basketIndex.value === (basketData.value.documents_count - 1))

  function setBasket(newBasketId) {
    if (newBasketId) {
      basketId.value = newBasketId
      getBasketData(newBasketId)
    }
    else {
      basketId.value = null
      basketData.value = {}
      currentDocumentData.value = {}
    }
  }

  function setBasketIndex(newBasketIndex) {
    if (newBasketIndex >= 0) {
      basketIndex.value = newBasketIndex
      getDocumentData(basketId.value, newBasketIndex)
    }
    else {
      basketIndex.value = null
      currentDocumentData.value = {}
    }
  }

  function getBasketData(basketId) {
    axios.get(`/api/baskets/${ basketId }`).then( r => basketData.value = r.data )
  }

  function getDocumentData(basketId, basketIndex) {
    axios.get(`/api/baskets/${ basketId }/documents/${ basketIndex }`).then(r => currentDocumentData.value = r.data)
  }

  const route = useRoute()
  const router = useRouter()
  const navigateToBasketIndex = (newBasketIndex) => {
    router.push({ name: route.name, params: { ...route.params, basketIndex: newBasketIndex.toString() }
    })
  }

  return {
    basketId,
    basketIndex,
    basketData,
    currentDocumentData,
    isFirstDoc,
    isLastDoc,
    setBasket,
    setBasketIndex,
    getBasketData,
    getDocumentData,
    navigateToBasketIndex
  }
})

